import { jsxs, jsx } from "react/jsx-runtime";
const IconCalendarAltSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M10.001 16.333a.834.834 0 1 0 0-1.668.834.834 0 0 0 0 1.668Zm4.167 0a.834.834 0 1 0 0-1.667.834.834 0 0 0 0 1.667Zm0-3.333a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666Zm-4.167 0a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667Zm5.834-10H15v-.833a.833.833 0 1 0-1.666 0V3H6.668v-.833a.833.833 0 1 0-1.667 0V3h-.833a2.5 2.5 0 0 0-2.5 2.5v11.667a2.5 2.5 0 0 0 2.5 2.5h11.667a2.5 2.5 0 0 0 2.5-2.5V5.5a2.5 2.5 0 0 0-2.5-2.5Zm.833 14.167a.833.833 0 0 1-.833.833H4.168a.833.833 0 0 1-.833-.833v-7.5h13.333v7.5Zm0-9.167H3.335V5.5a.833.833 0 0 1 .833-.833h.833V5.5a.833.833 0 0 0 1.667 0v-.833h6.667V5.5A.833.833 0 1 0 15 5.5v-.833h.834a.833.833 0 0 1 .833.833V8ZM5.835 13a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666Zm0 3.333a.834.834 0 1 0 0-1.667.834.834 0 0 0 0 1.667Z" })
    ]
  }
);
export {
  IconCalendarAltSvg
};
